/* global pay */

import React, { useEffect } from 'react';
import baseTheme from "@vkontakte/vkui-tokens/themes/vkBase";

const TinkoffForm = (props) => {

    const { description, amount, email, phone, data } = props;

    useEffect(() => {
        const loadScript = (url, callback) => {
            const script = document.createElement('script');
            script.src = url;
            script.onload = callback;
            document.body.appendChild(script);
        };

        const handleSubmit = (e) => {
            e.preventDefault();
            const { description, amount, email, phone, receipt } = e.target;

            if (receipt) {
                if (!email.value && !phone.value) {
                    email.value = ""
                    phone.value = "+79999999999"
                }

                receipt.value = JSON.stringify({
                    "EmailCompany": "berezovoy@mail.ru",
                    "Taxation": "usn_income",
                    "Items": [
                        {
                            "Name": description.value || "Оплата",
                            "Price": amount.value + '00',
                            "Quantity": 1.00,
                            "Amount": amount.value + '00',
                            "PaymentMethod": "full_payment",
                            "PaymentObject": "service",
                            "Tax": "none"
                        }
                    ]
                });
            }

            if (typeof pay !== "undefined") {
                pay(e.target);
            } else {
                alert("Ошибка: Функция pay не найдена.");
            }
        };

        loadScript("https://securepay.tinkoff.ru/html/payForm/js/tinkoff_v2.js", () => {
            const form = document.forms["payform-tinkoff"];
            form.addEventListener("submit", handleSubmit);
        });
    }, []);

    return (
        <>
            <style>
                {`
          .payform-tinkoff {
              display: -webkit-box;
              display: -ms-flexbox;
              display: flex;
              margin: 2px auto;
              -webkit-box-orient: vertical;
              -webkit-box-direction: normal;
              -ms-flex-direction: column;
              flex-direction: column;
          }
          .payform-tinkoff-row:focus {
              background-color: #FFFFFF;
              border: 1px solid #616871;
              border-radius: 4px;
          }
        `}
            </style>

            <script src="https://securepay.tinkoff.ru/html/payForm/js/tinkoff_v2.js"></script>

            <form className="payform-tinkoff" name="payform-tinkoff" id="payform-tinkoff">
                <input className="payform-tinkoff-row" type="hidden" name="terminalkey" value="1700477153134" />
                <input className="payform-tinkoff-row" type="hidden" name="frame" value="false" />
                <input className="payform-tinkoff-row" type="hidden" name="language" value="ru" />
                <input className="payform-tinkoff-row" type="hidden" name="receipt" value="" />
                <input className="payform-tinkoff-row" type="hidden" placeholder="Сумма заказа" name="amount" value={amount} />
                <input className="payform-tinkoff-row" type="hidden" placeholder="Номер заказа" name="order" />
                <input className="payform-tinkoff-row" type="hidden" placeholder="Описание заказа" name="description" value="Оплата пабликов/групп" />
                <input className="payform-tinkoff-row" type="hidden" placeholder="ФИО плательщика" name="name" value={props.name} />
                <input className="payform-tinkoff-row" type="hidden" placeholder="E-mail" name="email" value={props.email} />
                <input className="payform-tinkoff-row" type="hidden" placeholder="Контактный телефон" name="phone" value={props.phone} />
                <input className="payform-tinkoff-row" type="hidden" name="DATA" value={props.data} />
                <input
                    className="payform-tinkoff-row payform-tinkoff-btn"
                    type="submit"
                    style={{ fontFamily: "VK Sans Display", fontSize: "14px", fontWeight: "500", color: baseTheme.colorTextContrast.normal, border: "none", borderRadius: "10px", backgroundColor: baseTheme.colorAccentBlue.normal, height: "52px", marginBottom: "6px"}}
                    value={props.button} />
            </form>
        </>
    );
};

export default TinkoffForm;